<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
  <b-card title="Devices">
 

    <!-- table -->
    <vue-good-table
      :columns="$user.main_account==true && $active_account==null ? columnsMain : columns"
      :rows="devices"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >
        
     
      
        <span v-if="props.column.field === 'action'">
          <b-button v-if="props.row.active=='1'" variant="danger"   @click="disableDevice(props.row.id)">
           Disable
          </b-button>
          <b-button v-else variant="danger" disabled>
            Disable
          </b-button>
        </span>
        <span v-else-if="props.column.field === 'active'">
          <span>
            <b-badge
          pill
          class="badge-pill-force"
          :variant="props.row.active=='1' ? 'success' : 'danger'"
        >
        &nbsp;
        </b-badge>
 
       
          </span>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Page 1 de
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> sur {{ props.total }} résultats </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="totalRows"
              v-model="currentPage"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
     
      </template>
    </vue-good-table>

  </b-card>
</b-overlay>
</template>

<script>
import {BModal, BButton, VBModal,BImg,BOverlay, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest, Woocommerce} from '@simb2s/senseye-sdk'
import { VueGoodTable } from 'vue-good-table'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BBadge,BImg,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,

    BOverlay,
    BButton
  },
  data() {
    return {
      devices:[],
      pageLength: 10,
      dir: false,
      loading:true,
      totalRows:0,
      currentPage:1,
      selectedItem:null,
      columns: [
        {
            label: 'Last use',
          field: 'last_use',
          type:'number'
        },
        {
          label: 'ID',
          field: 'device_id',
        },
        {
          label: 'Active',
          field: 'active',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      columnsMain: [
        {
          label: 'Account',
          field: 'user.name',
        },
        {
            label: 'Last use',
          field: 'last_use',
          type:'number'
        },
        {
          label: 'ID',
          field: 'device_id',
        },
        {
          label: 'Active',
          field: 'active',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
      rows: [],
      searchTerm: '',

    }
  },
  computed: {
    activeAccount() {
      return this.$active_account
    },
  },
  methods: {
    async loadDevicesData() {
      this.loading = true
      if (this.$user.main_account == true && this.$active_account == null) {
        var devices = await APIRequest.list_with_request('user-devices', '?main_user=' + localStorage.id_user_senseye_auth + '&limit=' + this.pageLength + '&order=desc')
      } else {
        var user_id = this.$active_account ? this.$active_account.id : localStorage.id_user_senseye_auth
        var devices = await APIRequest.list('user-devices', user_id, null, this.pageLength, null, null, null, null, null, null, null, 'desc')
      }

      this.totalRows = devices[1]
      this.devices = devices[0]
      this.loading = false
    },
    async disableDevice(id) {
      this.loading = true
      await APIRequest.update('user-devices', id, { active: 'false' })
      await this.loadDevicesData()
    },
  },
  watch: {
    activeAccount() {
      const wasNotFirstPage = this.currentPage !== 1
      this.currentPage = 1
      if (!wasNotFirstPage) {
        this.loadDevicesData()
      }
    },
    currentPage: async function () {
      this.loading = true
      let offset = this.currentPage * this.pageLength

      if (this.$user.main_account == true && this.$active_account == null) {
        var devices = await APIRequest.list_with_request('user-devices', '?main_user=' + localStorage.id_user_senseye_auth + '&limit=' + this.pageLength + '&order=desc' + '&offset=' + offset)
      } else {
        var user_id = this.$active_account ? this.$active_account.id : localStorage.id_user_senseye_auth
        var devices = await APIRequest.list('user-devices', user_id, null, this.pageLength, offset, null, null, null, null, null, null, 'desc')
      }
      this.devices = devices[0]

      this.loading = false
    },
  },
  async mounted() {
    await this.loadDevicesData()
  }
}
</script>

<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';
.badge-pill-force
{
  width:15px !important;
  height:15px !important;
  border-radius:50%;
  padding:0 !important;
  display:block;
}
</style>
